import React from 'react';

import { Box, BoxProps } from '@mui/material';
import config from 'src/config';

import FavoriteCourseIconButton from '@components/share/custom/likeAndShareCourse/favoriteCourseIconButton';
import ShareCourseIconButton from '@components/share/custom/likeAndShareCourse/shareCourseIconButton';
import { useMediaQueryDevice } from '@helpers/use';
import useCourseDetail from '@hooks/course/useCourseDetail';
import { CourseEntity } from '@redux/course/type/courseDetailType';

type LikeAndShareCourseProps = {
  courseDetailSeo: CourseEntity;
  sx?: BoxProps['sx'];
};

const LikeAndShareCourse = ({ courseDetailSeo, sx = {} }: LikeAndShareCourseProps) => {
  const { id: courseId } = courseDetailSeo;
  const { mailContent, mailSubject, isUseMailTemplate, tweeterContent } = useCourseDetail();
  const { matchesMobile } = useMediaQueryDevice();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: {
          lg: 'flex-start',
          xs: 'flex-end',
        },
        alignItems: {
          lg: 'center',
          xs: 'flex-start',
        },
        minWidth: '108px',
        marginLeft: '24px',
        ...sx,
      }}
    >
      <FavoriteCourseIconButton courseId={courseId} />
      <ShareCourseIconButton
        courseId={courseId}
        courseUrl={`${config.APP_DOMAIN}/courses/${courseId}`}
        isUseMailTemplate={isUseMailTemplate}
        courseMailContent={mailContent}
        courseMailSubject={mailSubject}
        courseTweeterContent={tweeterContent}
        placement={matchesMobile ? 'bottom-start' : 'bottom'}
      />
    </Box>
  );
};

export default LikeAndShareCourse;
